import LumiereVideo from './src/components/LumiereVideo.vue';
import './src/assets/utils.scss';
export * from './src/components/VideoPlayer';
export * from './src/components/types';
export default LumiereVideo;
